import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";

export default function Footer({ siteInfo }) {
  const hasLogo = !!siteInfo?.logo_path;
  return (
    <footer data-testid="site-footer" className="bg-sand-100 border-t border-sand-300 py-12">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div className="flex items-center gap-4">
          {hasLogo && (
            <img
              src={fileUrl(siteInfo.logo_path)}
              alt={siteInfo?.company_name || "Logo"}
              className="h-14 w-auto object-contain"
            />
          )}
          <div>
            <p className="font-display text-2xl text-stone-900">{siteInfo?.company_name}</p>
            <p className="text-sm text-stone-600 mt-1">{siteInfo?.tagline}</p>
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-4 md:gap-8 text-sm text-stone-600">
          <p>© {new Date().getFullYear()} {siteInfo?.company_name}. Alle Rechte vorbehalten.</p>
          <Link to="/impressum" data-testid="footer-impressum-link" className="hover:text-clay transition-colors">Impressum</Link>
          <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:text-clay transition-colors">Datenschutz</Link>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-clay transition-colors">
            Admin
          </Link>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 sm:px-12 mt-6 pt-6 border-t border-sand-300 text-center md:text-right">
        <a
          href="https://www.kauzwerk.de"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-credit"
          className="text-xs text-stone-600 hover:text-clay transition-colors tracking-wider"
        >
          made by <span className="font-display">KauzWerk</span> · www.kauzwerk.de
        </a>
      </div>
    </footer>
  );
}
